/**
 * Response envelope shared by every BlackBlack API endpoint.
 * Success:  { data, meta? }
 * Failure:  { error: { code, message, details? } }
 */
export interface ApiSuccess<T> {
  data: T;
  meta?: PageMeta;
}

export interface ApiFailure {
  error: {
    code: ErrorCode;
    message: string;
    details?: Record<string, string>;
  };
}

export type ApiResponse<T> = ApiSuccess<T> | ApiFailure;

/** Cursor-based pagination: stable under inserts, works at any scale. */
export interface PageMeta {
  nextCursor: string | null;
}

export interface Page<T> {
  items: T[];
  nextCursor: string | null;
}

export type ErrorCode =
  | 'BAD_REQUEST'
  | 'VALIDATION_FAILED'
  | 'UNAUTHENTICATED'
  | 'FORBIDDEN'
  | 'NOT_FOUND'
  | 'CONFLICT'
  | 'RATE_LIMITED'
  | 'PAYLOAD_TOO_LARGE'
  | 'UNSUPPORTED_MEDIA_TYPE'
  | 'ACCOUNT_SUSPENDED'
  | 'INTERNAL';
